<template>
  <div class="countDownBlock">
    <div class="headerText">
      <slot>Time remaining</slot>
    </div>
    <div class="is-flex block">
      <div class="">
        <p class="digit">
          {{ days | two_digits }}
        </p>
        <p class="text">
          Days
        </p>
      </div>
      <div class="">
        <p class="digit">
          {{ hours | two_digits }}
        </p>
        <p class="text">
          Hours
        </p>
      </div>
      <div class="">
        <p class="digit">
          {{ minutes | two_digits }}
        </p>
        <p class="text">
          Minutes
        </p>
      </div>
      <div class="">
        <p class="digit">
          {{ seconds | two_digits }}
        </p>
        <p class="text">
          Seconds
        </p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'Countdown',
      filters: {
        two_digits: function(value) {
          if (value.toString().length <= 1) {
            return '0' + value.toString()
          }
          return value.toString()
        }
      },
      props: {
        date: {
          type: String,
        }
      },

      data() {
        return {
          normDate: null,
          now: Math.trunc((new Date()).getTime() / 1000)
        }
      },
      computed: {
        seconds() {
          return (this.normDate - this.now) % 60
        },

        minutes() {
          return Math.trunc((this.normDate - this.now) / 60) % 60
        },

        hours() {
          return Math.trunc((this.normDate - this.now) / 60 / 60) % 24
        },

        days() {
          return Math.trunc((this.normDate - this.now) / 60 / 60 / 24)
        }
      },
      mounted() {
        this.normDate = Math.trunc(Date.parse(this.date) / 1000)
        var self = this
        this.$nextTick(function() {
          window.setInterval(() => {
            self.now = Math.trunc((new Date()).getTime() / 1000)
          }, 1000)
        })
      }
    }
</script>

<style scoped lang="less">npm

  .headerText {
    font-weight: 900;
    font-family: 'Roboto', serif;
    font-size: 17px;
  }

  .countDownBlock {
    user-select: none;
    background-color: #34495e;
    color: #ABABAB;
    text-align:center;
    padding-top:10px;
  }
  .block {
    justify-content: center;
    display: flex;
    flex-direction: row;
    & > div {
      margin:10px;
    }
  }

  .text {
    color: #1abc9c;
    font-size: 15px;
    font-family: 'Roboto Condensed', serif;
    font-weight: 400;
    margin-top:10px;
    margin-bottom: 10px;
    text-align: center;
  }

  .digit {
    color: #ecf0f1;
    font-size: 15px;
    font-weight: 100;
    font-family: 'Roboto', serif;
    margin: 10px;
    text-align: center;
  }
</style>
